import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';


export const createWorkfromHome = createAsyncThunk(
  'WorkFromHome/createWorkfromHome',
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.post('/workfromhome', data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to create work from home ');
    }
  }
);
export const fetchAllWorkformHome = createAsyncThunk(
  'WorkFromHome/fetchallworkfromhome',
  async (_, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get('/workfromhome');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to get Data');
    }
  }
);
export const getworkfromhomeById = createAsyncThunk(
  'WorkFromHome/getworkfromById',
  async ( {Id}: any, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get(`/workfromhome/${Id}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to Get Data by Id');
    }
  }
);
export const getworkfromhomeByEmployeeId = createAsyncThunk(
  'WorkFromHome/getworkfromByemployeeId',
  async ( {Id}: any, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get(`/workfromhome/employeeId/${Id}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to Get Data by Id');
    }
  }
);
export const UpdateWorkfromHome = createAsyncThunk(
  'WorkFromHOme/UpdateWorkfromHome',
  async ({Id ,data}: any, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.put(`/workfromhome/${Id}`, data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to update WorkFromhome');
    }
  }
);
export const UpdateWorkfromHomeByAdmin = createAsyncThunk(
  'WorkFromHOme/UpdateWorkfromHomeByadmin',
  async ({Id ,data}: any, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.put(`/workfromhome/admin/${Id}`, data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to update WorkFromhome');
    }
  }
);
export const DeleteWorkfromHome = createAsyncThunk(
  'WorkfromHome/deleteWorkLog',
  async (Id: any, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.delete(`/workfromhome/${Id}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to delete WorkFromHome');
    }
  }
);
export const fetchWorkFromHomeBySupervisorHierarchy = createAsyncThunk(
  "workFromHome/fetchWorkFromHomeBySupervisorHierarchy",
  async (
    { supervisorId, includeSelf = false }: { supervisorId: number; includeSelf?: boolean },
    { rejectWithValue }
  ) => {
    try {
      const response = await employeeServiceApiInstance.get(
        `/workfromhome/supervisor/${supervisorId}`,
        { params: { includeSelf } }
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch supervisor hierarchy work from home requests"
      );
    }
  }
);